module.exports = __webpack_public_path__ + "static/images/clock-orange.3X1Z9vv.svg";